import deepFreeze from 'deep-freeze';

const config = {
    development: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g',
        },
        API_URL: `http://${process.env.HOST}:8000`,
    },
    production: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g',
        },
        API_URL: 'https://kwt-api.bcwatertool.ca',
    },
    testing: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g',
        },
        API_URL: `http://${process.env.HOST}:8000`,
    },
}[process.env.NODE_ENV];

// prevent changes to the config at runtime
const frozenConfig = deepFreeze(config);
export default frozenConfig;


// provide a vue plugin to access the config globall
// via this.$cfg
export const AppConfigPlugin = {
    install(Vue) {
        // We call Vue.mixin() here to inject functionality into all components.
        Vue.mixin({
            data() {
                return {
                    $cfg: {},
                };
            },
            beforeCreate() {
                this.$cfg = frozenConfig;
            },
        });
    },
};



// WEBPACK FOOTER //
// ./src/app.config.js